<template>
  <div class="element-info">
    <div class="row align-items-center">
      <div class="col-md-6" :class="selectorEnable">
        <div :class="`element-info-with-icon ${smaller ? 'smaller' : ''}`">
          <div class="element-info-icon" v-if="icon">
            <div :class="iconClass"></div>
          </div>
          <div class="element-info-text">
            <h5 class="element-inner-header">
              {{ title }}
              <span v-if="subtitle.length > 0" class="element-inner-desc">{{ subtitle }}</span>
            </h5>
            <div v-if="this.$slots.default" class="up-controls">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="selector">
        <div class="element-actions" style="z-index: 3">
          <form class="form-inline justify-content-sm-end">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('Download the selected report (.csv)')"
              placement="bottom"
              v-if="$display('usage_report_download') && actionIcon && $can('DownloadReports')"
            >
              <div class="download-icon">
                <a :href="actionUrl">
                  <i class="fas fa-download"></i><span>{{ $t('Download report') }}</span>
                </a>
              </div>
            </el-tooltip>

            <select class="form-control form-control-sm rounded" v-model="selectorValue">
              <option v-for="(option, index) in selectorOptions" :value="option" :key="index">
                {{ option }}
              </option>
            </select>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    icon: { type: String },
    faIcon: { type: String },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    smaller: { type: Boolean, default: false },
    selector: { type: Boolean, default: false },
    selectorOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectorSelected: { type: String, default: '' },
    actionIcon: { type: [String, Boolean], default: false },
    actionUrl: { type: String, default: '' },
    actionIconExtraInfo: { type: Boolean, default: false },
    ExtraInfoModalName: { type: String, default: '' },
  },
  computed: {
    iconClass() {
      return this.faIcon ? `fa ${this.faIcon}` : this.icon;
    },
    selectorEnable() {
      return this.selectorOptions.length > 0 ? 'col-sm-8' : 'col-sm-12';
    },
    selectorValue: {
      set(value) {
        this.$emit('changeSelector', value);
      },
      get() {
        return this.selectorSelected;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mo-custom';
.download-icon {
  margin-right: 1rem;
}
.download-icon span {
  display: none;
  padding-left: 0.5em;
  font-size: 0.8em;
}
@media (min-width: $md) {
  .download-icon span {
    display: inline-block;
  }
}
</style>
